var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[(_vm.customReportId)?_c('CustomReportTable',{attrs:{"customReportId":_vm.customReportId,"customReportConfigurationId":_vm.favoriteReportId},on:{"name":_vm.setName}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }